import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Login.css";
import Footer from "../components/Footer";

import bgVideo from "../assets/bgVideo.mp4";
import leftLogo from "../assets/ciallogo.png";
import rightLogo from "../assets/krrlogo.jpg";

const API_URL = process.env.REACT_APP_API_URL;

function VerifyMobileOtp() {

    const [username, setUsername] = useState("");

    const [otp, setOtp] = useState("");

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [isResending, setIsResending] = useState(false);

    const [verified, setVerified] = useState(false);

    const handleVerify = async (e) => {

        e.preventDefault();

        if (!username.trim() || !otp.trim()) {

            toast.warn("Enter your username and the OTP sent to your mobile.");
            return;

        }

        setIsSubmitting(true);

        try {

            const res = await fetch(`${API_URL}/portal/verify-mobile-otp`, {

                method: "POST",

                headers: { "Content-Type": "application/json" },

                body: JSON.stringify({ username: username.trim(), otp: otp.trim() })

            });

            const data = await res.json();

            if (data.status) {

                toast.success(data.message);

                setVerified(true);

            } else {

                toast.error(data.message);

            }

        } catch (err) {

            console.error(err);

            toast.error("Unable to connect to server.");

        } finally {

            setIsSubmitting(false);

        }

    };

    const handleResend = async () => {

        if (!username.trim()) {

            toast.warn("Enter your username first.");
            return;

        }

        setIsResending(true);

        try {

            const res = await fetch(`${API_URL}/portal/resend-mobile-otp`, {

                method: "POST",

                headers: { "Content-Type": "application/json" },

                body: JSON.stringify({ username: username.trim() })

            });

            const data = await res.json();

            toast.success(data.message);

        } catch (err) {

            console.error(err);

            toast.error("Unable to connect to server.");

        } finally {

            setIsResending(false);

        }

    };

    return (

        <div className="login-page">

            <video className="background-video" autoPlay muted loop playsInline>
                <source src={bgVideo} type="video/mp4" />
            </video>

            <div className="video-overlay"></div>

            <div className="top-header">

                <img src={leftLogo} alt="CIAL Logo" className="header-logo left-logo" />

                <img src={rightLogo} alt="KRR Logo" className="header-logo right-logo" />

            </div>

            <div className="login-container">

                <div className="login-card">

                    <h2>Verify Mobile Number</h2>

                    {

                        verified ? (

                            <>
                                <p style={{ color: "#e5e7eb", textAlign: "center", marginBottom: "18px" }}>
                                    Your mobile number is verified. You can now log in.
                                </p>

                                <Link to="/" className="forgot-password-link">
                                    Back to login
                                </Link>
                            </>

                        ) : (

                            <form onSubmit={handleVerify}>

                                <div className="form-group">
                                    <label>Username</label>

                                    <input
                                        type="text"
                                        placeholder="Your username"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </div>

                                <div className="form-group">
                                    <label>OTP</label>

                                    <input
                                        type="text"
                                        placeholder="Code sent to your mobile"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                    />
                                </div>

                                <button className="login-btn" disabled={isSubmitting}>
                                    {isSubmitting ? "Verifying..." : "Verify"}
                                </button>

                                <button
                                    type="button"
                                    className="forgot-password-link"
                                    style={{ background: "none", border: "none", cursor: "pointer", width: "100%" }}
                                    onClick={handleResend}
                                    disabled={isResending}
                                >
                                    {isResending ? "Resending..." : "Resend OTP"}
                                </button>

                                <Link to="/" className="forgot-password-link">
                                    Back to login
                                </Link>

                            </form>

                        )

                    }

                </div>

            </div>

            <Footer transparent />

        </div>

    );

}

export default VerifyMobileOtp;
